export default __webpack_public_path__ + "static/media/DRG.d1ac9889.jpg";